import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { useEffect } from "react";


function CountUp({ value }: { value: number }) {
  const count = useMotionValue(0);
  const rounded = useTransform(count, Math.round);

  useEffect(() => {
    const controls = animate(count, value, {
      duration: 1.8,
      ease: "easeOut",
    });

    return controls.stop;
  }, [count, value]);

  return <motion.span>{rounded}</motion.span>;
}



export default function About() {
  return (
    <section id="about" className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          
          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: "easeOut" }}
          >
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              About{" "}
              <span className="text-blue-600">ThinkPack </span>
              <span className="text-orange-500">Technologies</span>
            </h2>

            <p className="text-base text-gray-700 mb-6 leading-relaxed">
              Thinkpack Technologies is a leading Nigerian tech solutions company
              dedicated to driving innovation, connectivity, and empowerment
              across Africa. We specialize in providing comprehensive digital
              solutions that bridge the gap between technology and everyday life.
            </p>

            <p className="text-base text-gray-700 mb-6 leading-relaxed">
              Our mission is to empower individuals and businesses through
              cutting-edge technology, reliable communication systems, and
              transformative digital services. From telecom solutions to fintech
              services, we're building the infrastructure that powers Nigeria's
              digital future.
            </p>

            <p className="text-base text-gray-700 leading-relaxed">
              With a focus on accessibility, reliability, and innovation, we're
              committed to creating opportunities and fostering growth in
              communities across Nigeria and beyond.
            </p>
          </motion.div>

          {/* Image Content */}
          <motion.div
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            className="relative"
          >
            <div className="w-full h-96 rounded-2xl overflow-hidden shadow-2xl">
              <motion.img
                initial={{ scale: 1.1 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1.2, ease: "easeOut" }}
                src="https://readdy.ai/api/search-image?query=Professional%20African%20business%20team%20collaborating%20in%20modern%20Nigerian%20tech%20office%2C%20diverse%20group%20of%20young%20professionals%20working%20together%20on%20digital%20projects%2C%20contemporary%20workspace%20with%20computers%20and%20technology%20equipment%2C%20bright%20natural%20lighting%2C%20innovation%20and%20teamwork%20atmosphere%2C%20clean%20professional%20environment%20with%20blue%20and%20orange%20accent%20colors&width=800&height=600"
                alt="About Thinkpack"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Experience Badge */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4, duration: 0.5 }}
              className="absolute -bottom-8 -right-8 bg-orange-500 text-white p-8 rounded-2xl shadow-xl"
            >
              <div className="text-4xl font-bold mb-2">
                <CountUp value={5} />+
              </div>
              <div className="text-sm font-medium">Years of Excellence</div>
            </motion.div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}
